import { useState, useEffect } from 'react';
import { getAllBusinessDefinition, IStageStatusPair } from 'wisestep-api';

interface IBusinessDefinition {
  businessDefinitionName: string;
  createdBy: string;
  createdOn: string;
  id: string;
  isArchive: boolean;
  jobOption: string;
  modifiedBy: string;
  modifiedOn: string;
  stageStatusData: IStageStatusPair[];
  workspaceId: string;
}

const useGetBusinessDefination = () => {
  const [businessDefinations, setBusinessDefinations] = useState<IBusinessDefinition[]>([]);

  useEffect(() => {
    const fetchBusineesDefinations = async () => {
      try {
        const res = await getAllBusinessDefinition();
        setBusinessDefinations(res?.data);
      } catch (error) {
        console.error('Error fetching Business Definations:', error);
        setBusinessDefinations([]);
      }
    };

    fetchBusineesDefinations();
  }, []);

  return { businessDefinations };
};

export default useGetBusinessDefination;
